export const allServiceTeamOption = {
  label: "All service teams",
  value: undefined,
} as const;

export const noServiceTeamOption = {
  label: "(None)",
  value: "null",
} as const;
